<div class="bc-visitor-history" *ngIf="dataLoaded">
  <div class="bc-panel-header">
    <svg-icon icon="history-outline" class="bc-panel-header-icon"></svg-icon>
    <span class="bc-panel-header-text">{{ 'bcVisitorHistory.historyTitle' | translate }}</span>

    <div class="bc-panel-input-wrapper bc-panel-input-iconed">
      <span class="bc-panel-input-icon fa fa-search"></span>
      <input type="text" class="bc-panel-input" [placeholder]="'bcVisitorHistory.searchPlaceholder' | translate" />
    </div>
  </div>

  <div class="bc-history-item-list" *ngIf="historyItems.length">
    <div class="bc-history-item-list-container">
      <div *ngFor="let historyItem of historyItems"
           class="history-item"
           [ngClass]="getHistoryItemClasses(historyItem.id)">
        <div class="history-content js-expand-history-details" (click)="flipDetailsState(historyItem.id)">
          <div class="history-item-icon">
            <svg-icon icon="{{ calculateHistoryItemIcon(historyItem) }}" [ngClass]="{'svg-icon-spin': historyItem.loading}" ></svg-icon>
          </div>

          <div class="history-item-content">
            <p class="truncated bc-timestamp">
              <span>{{ moment(historyItem.created).format('llll') }}</span>
              <app-copy-text-to-clipboard *ngIf="isItemChat(historyItem) && historyItem.isDetailsOpen"
                                          [linkText]="'bcChatMessages.copyChatId' | translate"
                                          [textToCopy]="historyItem.id">
              </app-copy-text-to-clipboard>
            </p>
            <p class="truncated first-line {{historyItem.type}}" attr.data-automation-id="bc-{{historyItem.type}}-history-first-line">
              {{historyItem.firstLine}}
            </p>

            <p class="truncated second-line {{historyItem.type}}" attr.data-automation-id="bc-{{historyItem.type}}-history-second-line">
              {{historyItem.secondLine}}
            </p>
          </div>

          <a class="history-item-more">
            <svg-icon icon="arrow-right"></svg-icon>
          </a>
        </div>

        <div *ngIf="(isItemChat(historyItem) || isItemTextChat(historyItem)) && historyItem.isDetailsOpen">
          <app-chat-messages
            *ngIf="historyItem.details"
            [messages]="historyItem.details"
            [workItemId]="historyItem.id"
            [workItemType]="historyItem.type"
            [workItemCreated]="historyItem.Created"></app-chat-messages>
        </div>

        <div *ngIf="isItemEmail(historyItem) && historyItem.isDetailsOpen">
          <app-email-viewer *ngIf="historyItem.details" [email]="historyItem.details" (bodyLoaded)="onEmailBodyFrameLoaded(historyItem)"></app-email-viewer>
        </div>
      </div>
    </div>
  </div>

  <div class="bc-no-item muted" *ngIf="historyItems.length === 0">
    <div class="media" [attr.data-automation-id]="'bc-history-media-item'">
      <div class="media-left media-middle">
        <svg-icon icon="chat-large"></svg-icon>
      </div>
      <div class="media-body">
        <p>{{ 'bcVisitorHistory.noHistoryYouAreTheFirstInteraction' | translate }}</p>
        <p>{{ 'bcVisitorHistory.noHistoryMakeThisConversationMemorable' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="!dataLoaded" class="loading-container"></app-loading>
